module.exports = "<app-team-list></app-team-list>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/teams/teams.component.html
// module id = ../../../../../src/app/teams/teams.component.html
// module chunks = main